import { createSelector } from 'reselect';

/**
 * Direct selector to the rootModal state domain
 */
const selectRootModalDomain = () => state => state.modal;

/**
 * Other specific selectors
 */

const selectModalType = () => createSelector(
  selectRootModalDomain(),
  (substate) => substate.modalType
);

const selectModalProps = () => createSelector(
  selectRootModalDomain(),
  (substate) => substate.modalProps
);

/**
 * Default selector used by RootModal
 */

const selectRootModal = () => createSelector(
  selectRootModalDomain(),
  (substate) => substate
);

export default selectRootModal;
export {
  selectRootModalDomain,
  selectModalType,
  selectModalProps,
};



// WEBPACK FOOTER //
// ./src/containers/RootModal/selectors.js